import SubjectAction from './Subject';

const ACTION = {
  ...SubjectAction.ACTION,
};

const ACTION_TYPES = {
  ...SubjectAction.ACTION_TYPES,
};

const Subject = {
  ACTION,
  ACTION_TYPES
}

export default Subject;